import React from "react";
import PropTypes from "prop-types";
import { useDictionary } from "hooks";
import Button from "@cayuse/shared-react.components.button";
import Modal from "@cayuse/shared-react.components.modal";
import VerticalSpacing from "@cayuse/shared-react.components.vertical-spacing";


const CommentDisplayModal = ({
	title,
	comment,
	open,
	onClose,
	commentHeader,
	cancelLabel
}) => {
	const dictionary = useDictionary("common.commentDisplayModal");

	return (
		<Modal open={open} onClose={onClose} ariaLabel={title || "Comment"}>
			<Modal.Header className="ui header whiteOnBlue">
				<h2>{title || "Comment"}</h2>
			</Modal.Header>

			<Modal.Content>
				<div className={"ui input"}>
					<b>{commentHeader || dictionary.columnHeaders?.comment || "Comment"}</b>
				</div>
				<VerticalSpacing/>
				<div className={"ui input"}>
					{comment || ""}
				</div>
			</Modal.Content>

			<VerticalSpacing/>

			<Modal.Actions>
				<div className="field">
					<Button secondary onClick={onClose}>
						{cancelLabel || dictionary.cancelCommentLabel || "Cancel"}
					</Button>
				</div>
			</Modal.Actions>
		</Modal>
	);
};

CommentDisplayModal.propTypes = {
	title: PropTypes.string,
	comment: PropTypes.string,
	visible: PropTypes.bool,
	onClose: PropTypes.func,
	commentHeader: PropTypes.string
};

export default CommentDisplayModal;